module.exports = __webpack_public_path__ + "img/3.2a2c46ca.jpg";